export const environment = {
  production: false,
  auth: {
    clientId: '4b7cb366-79bf-4f6f-8867-533d2853e290',
    tenantId: '329e91b0-e21f-48fb-a071-456717ecc28e',
    redirectUri: 'https://spa.verticalpowerdev.alzp.tgscloud.net',
    apiBaseUrl: 'https://wpuz5ev4q0.execute-api.eu-central-1.amazonaws.com', // API Gateway,
    scopeApi: 'api://4b7cb366-79bf-4f6f-8867-533d2853e290/vertical-power-spa-dev',
  }
};
